import { render } from "./CoursesPage.vue?vue&type=template&id=61b67ccf&scoped=true"
import script from "./CoursesPage.vue?vue&type=script&lang=js"
export * from "./CoursesPage.vue?vue&type=script&lang=js"

import "./CoursesPage.vue?vue&type=style&index=0&id=61b67ccf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b67ccf"]])

export default __exports__